import { useApplication } from '@/hooks/useApplication';
import { ConfigurationVariable } from '@/types/metadata/metadata';
import { synceventUtil } from '@/util/validation/syncevent';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { FC } from 'react';
import { ParamProps } from './ParamRenderer';

const ParamSyncEvent: FC<ParamProps> = (props) => {
  const configuration = props.configuration as ConfigurationVariable;
  const { application } = useApplication();

  const initialValue = synceventUtil().getValue(props.configuration, props.initialValue);

  const handleChange = (event: SelectChangeEvent) => {
    props.onChange([props.configuration.value, event.target.value]);
  };

  return (
    <FormControl fullWidth size='small' required={props.configuration.required}>
      <InputLabel id='select-syncevent-label'>{configuration.label}</InputLabel>
      <Select
        labelId='select-syncevent-label'
        id='select-syncevent'
        value={initialValue || ''}
        label={configuration.label}
        onChange={handleChange}
        required={props.configuration.required}
        error={!!props.errors?.length}
      >
        {application.syncevents
          ?.sort((a, b) => a.name.localeCompare(b.name))
          .map((syncevent, index) => (
            <MenuItem key={`menu.syncevent.${syncevent.name}.${index}`} value={syncevent.name}>
              {syncevent.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default ParamSyncEvent;
